import { connect } from 'react-redux';
import ServicePrLisitng from './servicePrListing';
import { bindActionCreators } from 'redux';
import { fetchGoLiveSites, getGOLiveFilterDropDown } from "services/redux/maintenance/goLiveSite/action";
import {
    getPrListingWithPo
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    prListData: state.siteListingReducer.prListData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrListingWithPo,
      getGOLiveFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServicePrLisitng);
